import PanelTable from './panel_table';
import { VStack, Text, HStack } from '@chakra-ui/react';
import { useEffect } from 'react';
import GroupModal from './groups/groups_modal';
import GroupsForm from './groups/groups_form';
import { addPanelToGroup, deletePanelFromGroup } from '../store/api_funcs';
import { getAllGroups } from '../store/api_funcs';
import { useState } from 'react';
import { useStores } from '../store/store_context';
import GroupModalMain from './groups/groups_modal_main';
import GroupForm from './groups/group_create_form';
import GroupDeleteForm from './groups/group_delete_form';
import ManyEditForm from './groups/group_many_edit';
const GroupTable = ({
  getPanelsByGroups,
  panelsByGroup,
  usersForPanelForm,
  panels,
}) => {
  const { pageStore } = useStores();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    getPanelsByGroups();
    getGroups();
  }, []);

  useEffect(() => {
    console.log(panelsByGroup);
  }, [panelsByGroup]);
  const getGroups = async () => {
    setGroups(await getAllGroups(pageStore.user_id, pageStore.token));
  };
  return (
    <VStack width={'100%'}>
      <HStack width={'100%'}>
        <GroupModalMain text={'Удалить панель из группы'}>
          <Text color={'#8B5CF6'} fontSize={22} fontWeight={700}>
            Удалить панель из группы
          </Text>
          <GroupsForm
            panels={panels}
            groups={groups}
            updatePanelsTable={getPanelsByGroups}
            onSubmit={deletePanelFromGroup}
            isDelete={true}
          />
        </GroupModalMain>
        <GroupModalMain text={'Добавить панель в группу'}>
          <Text color={'#8B5CF6'} fontSize={22} fontWeight={700}>
            Добавить панель в группу
          </Text>
          <GroupsForm
            panels={panels}
            groups={groups}
            updatePanelsTable={getPanelsByGroups}
            onSubmit={addPanelToGroup}
          />
        </GroupModalMain>
        <GroupModalMain text={'Создать группу'}>
          <Text color={'#8B5CF6'} fontSize={22} fontWeight={700}>
            Создать группу
          </Text>
          <GroupForm
            updatePanelsTable={getPanelsByGroups}
            updateGroups={getGroups}
          />
        </GroupModalMain>
        <GroupModalMain text={'Удалить группу'}>
          <VStack width={'100%'} align={'flex-start'}>
            <Text color={'#8B5CF6'} fontSize={22} fontWeight={700}>
              Удалить группу
            </Text>
            <GroupDeleteForm
              groups={groups}
              updateGroups={getGroups}
              updatePanelsTable={getPanelsByGroups}
            />
          </VStack>
        </GroupModalMain>
      </HStack>
      {groups.length > 0
        ? groups.map(group => {
            const groupPanels =
              panelsByGroup?.find(
                items => String(items?.[0]?.group_id) === String(group.group_id)
              ) || [];

            return (
              <VStack width={'100%'} key={group.group_id}>
                <HStack width={'100%'} justify={'space-between'}>
                  <Text
                    fontSize={24}
                    alignSelf={'flex-start'}
                    color={'#8B5CF6'}
                    fontWeight={700}
                  >
                    {group.group_name}
                  </Text>{' '}
                  <HStack>
                    <GroupModal many={true}>
                      <ManyEditForm
                        group_id={group.group_id}
                        updateGroups={getGroups}
                        updatePanelsTable={getPanelsByGroups}
                        groups={groups}
                        panels={panels}
                      />
                    </GroupModal>
                    <GroupModal>
                      <GroupsForm
                        panels={panels}
                        groups={groups}
                        updatePanelsTable={getPanelsByGroups}
                        onSubmit={addPanelToGroup}
                        defaultValue={group.group_name}
                        defaultGroupId={group.group_id}
                      />
                    </GroupModal>
                    <GroupModal isDelete={true}>
                      <GroupsForm
                        panels={panels}
                        groups={groups}
                        updatePanelsTable={getPanelsByGroups}
                        onSubmit={deletePanelFromGroup}
                        defaultValue={group.group_name}
                        defaultGroupId={group.group_id}
                        isDelete={true}
                      />
                    </GroupModal>
                  </HStack>
                </HStack>
                <PanelTable
                  getTablePanels={getPanelsByGroups}
                  panels={groupPanels}
                  usersForPanelForm={usersForPanelForm}
                  group={true}
                />
              </VStack>
            );
          })
        : null}
    </VStack>
  );
};

export default GroupTable;
